import React from "react";

export const DASHBOARD_RECENT_TAB_KEYS = {
    SEARCHES: "searches",
    PRODUCTS: "products",
    CAMPAIGNS: "campaigns",
};

const DASHBOARD_RECENT_TABS = [
    {
        key: DASHBOARD_RECENT_TAB_KEYS.SEARCHES,
        label: "Recent Searches",
    },
    {
        key: DASHBOARD_RECENT_TAB_KEYS.PRODUCTS,
        label: "Recent Products",
    },
    {
        key: DASHBOARD_RECENT_TAB_KEYS.CAMPAIGNS,
        label: "Recent Campaigns",
    },
];

const DashboardRecentTabs = ({
    activeTab = DASHBOARD_RECENT_TAB_KEYS.SEARCHES,
    onTabChange,
    className = "",
}) => (
    <div className={`overflow-x-auto overscroll-x-contain ${className}`}>
        <div
            role="tablist"
            aria-label="Dashboard recent sections"
            className="inline-flex min-w-max gap-1.5 rounded-lg border border-slate-200 bg-white p-1.5 shadow-sm"
        >
            {DASHBOARD_RECENT_TABS.map((tab) => {
                const isActive = activeTab === tab.key;

                return (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        onClick={() => onTabChange?.(tab.key)}
                        className={`whitespace-nowrap rounded-lg px-3.5 py-2 text-sm font-semibold transition-colors ${
                            isActive
                                ? "bg-indigo-100 text-indigo-700 shadow-sm"
                                : "text-slate-600 hover:bg-indigo-50 hover:text-indigo-700"
                        }`}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    </div>
);

export default DashboardRecentTabs;
